import { api } from '@/helpers/interceptors'
import { GET_AI_IMAGE_DETECTION, UPDATE_STATUS_AI_IMAGE_DETECTION } from '@/constants/path'
import moment from 'moment'

const initialMeta = {
  total_item_current_page: 20,
  item_per_page: 20,
  current_page: 1,
  total_page: null,
}

const state = () => ({
  aiImageDetectionList: null,
  aiImageDetectionUpdateAt: null,
  aiImageDetectionMeta: initialMeta,
  isToast: false,
  isError: false,
  isLoading: false,
  // Filter
  selectDate: [
    moment().format('YYYY-MM-DD'),
    moment().format('YYYY-MM-DD'),
  ],

  // Update
  submit: {
	isLoading: false,
	isError: false,
  },
})

// getters
const getters = {}

// actions
const actions = {
  async getAiImageDetection({ commit }, payload) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', false)
    try {
        const params = payload

        const res = await api(GET_AI_IMAGE_DETECTION, 'get', { params })

        commit('SET_AI_IMAGE_DETECTION', res?.data?.data)
        commit('SET_AI_IMAGE_DETECTION_META', res?.data?.meta)
        commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_AI_IMAGE_DETECTION', null)
      commit('SET_AI_IMAGE_DETECTION_META', initialMeta)
      commit('SET_LOADING', false)
      commit('SET_ERROR', true)

      throw error
    }
  },
	async updateStatusAiImageDetection({ commit }, payload) {
		commit('SET_SUBMIT_LOADING', true)
		commit('SET_SUBMIT_ERROR', false)

		try {
			let bodyFormData = new FormData()
			
			bodyFormData.append('id', payload.id)

			await api(UPDATE_STATUS_AI_IMAGE_DETECTION, 'post', bodyFormData)

			commit('SET_SUBMIT_LOADING', false)
		} catch (error) {
			commit('SET_SUBMIT_LOADING', false)
			commit('SET_SUBMIT_ERROR', true)
			commit('SET_ERROR', true)

			throw error
		}
	},
}

// mutations
const mutations = {
  SET_AI_IMAGE_DETECTION(state, payload) {
    state.aiImageDetectionList = payload
    state.aiImageDetectionUpdateAt = moment().format('YYYY-MM-DD HH:mm:ss')
  },
  SET_AI_IMAGE_DETECTION_META(state, payload) {
    state.aiImageDetectionMeta = payload
  },
  SET_ERROR(state, payload) {
    state.isError = payload
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  },
  SET_TOAST(state, payload) {
    state.isToast = payload
  },
  // Filter
  SET_SELECT_DATE(state, payload) {
    state.selectDate = payload
  },
  // Update
  SET_SUBMIT_LOADING(state, payload) {
	state.submit.isLoading = payload
  },
  SET_SUBMIT_ERROR(state, payload) {
	state.submit.isError = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
